export default function IconEmpty() {
    return (
        <svg
            width="1em"
            height="0.7em"
            viewBox="0 0 136 97"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="ef-check-in-activities-coupon-empty-icon"
        >
            <g id="会员体系2.0" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="登录后-表格-空状态" transform="translate(-120.000000, -277.000000)" fillRule="nonzero">
                    <g id="编组-2备份-2" transform="translate(50.000000, 278.000000)">
                        <g id="invalidName" transform="translate(70.000000, 0.000000)">
                            <ellipse id="椭圆形" fillOpacity="0.402" fill="#E0E1E1" cx="68" cy="76.7307692" rx="68" ry="18.2692308"></ellipse>
                            <polyline
                                id="路径"
                                stroke="#C3C9CE"
                                strokeWidth="1.5876"
                                fill="#FFFFFF"
                                strokeLinejoin="round"
                                points="14.7826087 24.8461538 38.4347826 0 97.5652174 0 121.217391 24.8461538"
                            ></polyline>
                            <polyline
                                id="路径"
                                fill="#FFFFFF"
                                points="14.7826087 46.7692308 44.3478261 13.1538462 91.6521739 13.1538462 121.217391 46.7692308"
                            ></polyline>
                            <path
                                d="M14.7826087,24.8461538 L45.599913,24.8461538 C47.5586522,24.8461538 49.2856237,26.1160059 49.8484348,27.9709231 L52.0702609,35.2946923 C52.8204969,37.7681081 55.1231687,39.4619112 57.7349565,39.4615385 L82.818087,39.4615385 C85.4289212,39.4614594 87.7306895,37.7684729 88.4813043,35.2961538 L90.7046087,27.9709231 C91.2672626,26.1165238 92.9934598,24.8461538 94.9516522,24.8461538 L121.217391,24.8461538 L121.217391,70.1538462 C121.217391,74.9969586 117.246352,78.9230769 112.347826,78.9230769 L23.6521739,78.9230769 C18.7536483,78.9230769 14.7826087,74.9969586 14.7826087,70.1538462 L14.7826087,24.8461538 Z"
                                id="路径"
                                stroke="#C3C9CE"
                                strokeWidth="1.5876"
                                fill="#EBEDEF"
                                strokeLinejoin="round"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
